import { render, staticRenderFns } from "./commodityDetails.vue?vue&type=template&id=4d25fe89&scoped=true&"
import script from "./commodityDetails.vue?vue&type=script&lang=js&"
export * from "./commodityDetails.vue?vue&type=script&lang=js&"
import style0 from "./commodityDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./commodityDetails.vue?vue&type=style&index=1&id=4d25fe89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25fe89",
  null
  
)

export default component.exports